
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/blog/[project]",
      function () {
        return require("private-next-pages/[locale]/blog/[project]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/blog/[project]"])
      });
    }
  